
export default {
  name: "IconSvg",
  props: {
    iconClass: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: ""
    }
  },
  serverCacheKey: props => props.iconClass,
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`
    }
  }
}
